module.exports = __webpack_public_path__ + "static/media/norutec.caa2b30d.png";